"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var List_1 = __importDefault(require("@material-ui/core/List"));
var ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
var ListItemSecondaryAction_1 = __importDefault(require("@material-ui/core/ListItemSecondaryAction"));
var ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
var ListItemAvatar_1 = __importDefault(require("@material-ui/core/ListItemAvatar"));
var Avatar_1 = __importDefault(require("@material-ui/core/Avatar"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
var confirm_1 = __importDefault(require("./confirm"));
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            width: '100%',
            maxWidth: 360,
            backgroundColor: theme.palette.background.paper
        }
    });
});
var getAvatar = function (value) {
    if (!value.logUser || !value.logUser.firstName || !value.logUser.lastName) {
        return '';
    }
    return (value.logUser.firstName[0] + value.logUser.lastName[0]).toUpperCase();
};
exports["default"] = (function (_a) {
    var list = _a.list, onDelete = _a.onDelete;
    var _b = react_1["default"].useState(undefined), selectedValue = _b[0], setValue = _b[1];
    var isOpen = !!selectedValue;
    var classes = useStyles();
    var handleConfirmDelete = function (t) {
        if (t) {
            onDelete(selectedValue || 0);
        }
        setValue(undefined);
    };
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(List_1["default"], { className: classes.root }, list.map(function (value) {
            var avatar = getAvatar(value);
            return (react_1["default"].createElement(ListItem_1["default"], { key: value.id },
                react_1["default"].createElement(ListItemAvatar_1["default"], null,
                    react_1["default"].createElement(Avatar_1["default"], null, avatar)),
                react_1["default"].createElement(ListItemText_1["default"], { primary: value.message, secondary: value.logUser.firstName }),
                react_1["default"].createElement(ListItemSecondaryAction_1["default"], null,
                    react_1["default"].createElement(IconButton_1["default"], { edge: "end", onClick: function () { return setValue(value.id); } },
                        react_1["default"].createElement(Delete_1["default"], null)))));
        })),
        react_1["default"].createElement(confirm_1["default"], { isOpen: isOpen, onClick: handleConfirmDelete })));
});
